module.exports = __webpack_public_path__ + "static/media/KapOrg-logo.cd9f708b.svg";